export default __webpack_public_path__ + "c8ef18e88d127938f2a7f3daf51da21f.svg";